<template>
  <IziGrid>
    <IziCol>
      <IziInput
        v-model:value="formGroup.timer.value"
        type="number"
        label="Timer"
        name="timer"
        :msg="msg.timer"
        @blur="blur('timer')"
      />
    </IziCol>
  </IziGrid>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import BaseForm from "../../baseForm/baseForm.vue";
import { FormGroup } from "../../../model/FormGroup.model";
@Options({})
export default class Timer extends BaseForm {
  public timer = 30;
  public formGroup: FormGroup = {
    timer: {
      rules: [],
      value: this.timer
    }
  };
}
</script>
<style lang="scss" scoped></style>
